import { cn } from "@/lib/utils";

function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
}

export default function PlayerAvatar({ player, size = "md", className = "" }) {
  const sizes = {
    sm: "w-9 h-9 text-xs",
    md: "w-12 h-12 text-sm",
    lg: "w-20 h-20 text-xl",
    xl: "w-32 h-32 text-3xl",
  };
  const photo = player?.photo_url;
  return (
    <div
      className={cn(
        "rounded-md overflow-hidden flex items-center justify-center font-display font-black uppercase tracking-wider bg-burgundy text-white ring-1 ring-white/10 shrink-0",
        sizes[size] || sizes.md,
        className
      )}
      data-testid={`avatar-${player?.slug || "x"}`}
    >
      {photo ? (
        <img src={photo} alt={player?.player_name} className="w-full h-full object-cover" />
      ) : (
        <span>{initials(player?.player_name)}</span>
      )}
    </div>
  );
}
